import { render, staticRenderFns } from "./ContestOfferMainData.vue?vue&type=template&id=52a8b2c6&scoped=true&"
import script from "./ContestOfferMainData.vue?vue&type=script&lang=js&"
export * from "./ContestOfferMainData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8b2c6",
  null
  
)

export default component.exports